import React from "react";
import AddProduct from "../addProduct/addProduct";

function Catalogue(props) {
    return (
        <AddProduct props={props} />
    )
}
export default Catalogue;